// extracted by mini-css-extract-plugin
module.exports = {"list":"About_list__3dXio","title":"About_title__IYoGZ"};